export default "/images/5.png?5afc274030380adaa0e742db1ccf039a";